import styles from './W_Loader.module.css';
import ScreenSaver from '@/assets/images/A_ScreenSaver.png';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface W_LoaderProps {
  isLoading?: boolean;
  isHiding?: boolean;
}

export default function W_Loader({
  isLoading = true,
  isHiding = false,
}: W_LoaderProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.hiding]: !isLoading || isHiding,
      })}
    >
      <div className={styles.image_wrapper}>
        <img src={ScreenSaver} alt='Screen Saver' />
      </div>
      <span className={cn(styles.text, 'text-p-6')}>
        {t('common.loading').replace('...', '')}
        <span className={styles.dots}>
          <span className={styles.dot}>.</span>
          <span className={styles.dot}>.</span>
          <span className={styles.dot}>.</span>
        </span>
      </span>
      <div className={styles.circle_1}></div>
      <div className={styles.circle_2}></div>
    </div>
  );
}
